<template>
  <main class="guests-page">
    <div class="guests-page__head">
      <h1 class="guests-page__title">Nuovo ospite</h1>
      <router-link to="/guests" class="villa-btn villa-btn--ghost">
        <i class="fa-solid fa-arrow-left"></i> Torna alla lista
      </router-link>
    </div>

    <GuestForm
      submit-label="Crea ospite"
      :submitting="submitting"
      @submit="onSubmit"
      @cancel="goBack"
    />
  </main>
</template>

<script>
import { mapActions } from "vuex";
import GuestForm from "@/components/GuestForm.vue";

export default {
  name: "CreateGuestPage",
  components: { GuestForm },
  data() {
    return { submitting: false };
  },
  methods: {
    ...mapActions(["createGuest"]),
    goBack() {
      this.$router.push("/guests");
    },
    async onSubmit(payload) {
      this.submitting = true;
      try {
        await this.createGuest(payload);
        this.$toast.success("Ospite creato con successo!");
        this.$router.push("/guests");
      } catch (err) {
        this.$toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            err?.response?.data?.details ||
            "Errore durante la creazione dell'ospite."
        );
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style src="@/css/GuestsPage.css" />
